export default ({
    name = null,
    type = 'abroad',
    convention = 'NMC',
    numOfAdults = '01',
    sameDayReturn = false,
    showTwoWay = false,
    isSupportOneWay = false,
    isShowInfants = false,
    isDomesticVoucher = false,
    isEilatResident = false,
    isOtefResident = false,
    isSoldier = false,
    isPoliceman = false,
    disableNextOnClear = false,
    supportBudget = false,
    supportFlexSearch = false,
    supportFromAbroadFlight = false,
    supportMultiDestination = false,
    isDomesticModule = false,
    onlyFlightModule = false,
    onlyHotelModule = false,
    specificDatesRequired = false,
    definedDatesRequired = false,
    definedDestRequired = false,
    datesPaintingSupported = false,
    autoCompleteSupported = false,
    subjectSupported = false,
    openCalendarSupported = false,
    calendarType = 'days',
    isSummerWinter = false
}) => ({
    name,
    type,
    convention,
    numOfAdults,
    sameDayReturn,
    showTwoWay,
    isSupportOneWay,
    isShowInfants,
    isDomesticVoucher,
    isEilatResident,
    isOtefResident,
    isSoldier,
    isPoliceman,
    disableNextOnClear,
    supportBudget,
    supportFlexSearch,
    supportFromAbroadFlight,
    supportMultiDestination,
    isDomesticModule,
    onlyFlightModule,
    onlyHotelModule,
    specificDatesRequired,
    definedDatesRequired,
    definedDestRequired,
    datesPaintingSupported,
    autoCompleteSupported,
    subjectSupported,
    openCalendarSupported,
    calendarType,
    isSummerWinter
});